import { Injectable } from '@angular/core';
import { zip } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { DirectMsg, NewMsg } from '../../models/Core/DirectMsg';
import { User } from '../../models/Core/User';
import { AuthenticationService } from '../auth/authentication.service';
import { RequestService } from '../request.service';

@Injectable()
export class DirectMsgService {
  api = {
    root: '/users/direct-msg',
  };

  constructor(
    private client: RequestService,
    private auth: AuthenticationService,
  ) {}

  post(msg: NewMsg) {
    return this.client.post<NewMsg, any>({
      uri: this.api.root + '/' + msg.recipient._id,
      body: msg,
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }

  get(user: User) {
    return zip(
      this.client.get<DirectMsg[]>({
        uri: this.api.root + '/' + user._id,
        handlers: {
          success: () => void 0,
          error: () => void 0,
        },
      }),
      this.auth.getCurrentUser,
    ).pipe(
      map(([msgs, me]) =>
        msgs.map(msg => {
          if ((msg.recipient as any) === user._id) {
            msg.recipient = user;
            msg.created_by = me as unknown as User;
          } else {
            msg.recipient = me as unknown as User;
            msg.created_by = user;
          }

          msg.created_at = new Date(msg.created_at);
          return msg;
        }),
      ),
      share(),
    );
  }
}
